import _JSON$stringify from "babel-runtime/core-js/json/stringify";
var aes = require("./aes").CryptoJS;

var STORAGE_USER_KEY = "STORAGE_USER_KEY";

export default {
  getLocal: function getLocal() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_USER_KEY;

    return JSON.parse(window.localStorage.getItem(key));
  },
  setLocal: function setLocal(res) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_USER_KEY;
    var isSaveOldData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (isSaveOldData) {
      if (this.getLocal(key)) {
        var oldData = this.getLocal(key);
        return window.localStorage.setItem(key, _JSON$stringify(oldData.concat(res)));
      }
    }
    return window.localStorage.setItem(key, _JSON$stringify(res));
  },
  getSession: function getSession() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_USER_KEY;

    return JSON.parse(window.sessionStorage.getItem(key));
  },
  setSession: function setSession(res) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_USER_KEY;
    var isSaveOldData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (isSaveOldData) {
      if (this.getLocal(key)) {
        var oldData = this.getLocal(key);
        return window.sessionStorage.setItem(key, _JSON$stringify(oldData.concat(res)));
      }
    }
    return window.sessionStorage.setItem(key, _JSON$stringify(res));
  },
  removeLocal: function removeLocal(key) {
    localStorage.removeItem(key);
  },
  handleTime: function handleTime(time) {
    var obj = {};
    var dateTime = new Date(time);
    obj.day = parseInt(time / (1000 * 60 * 60 * 24));
    obj.hour = dateTime.getHours();
    obj.minutes = dateTime.getMinutes();
    obj.seconds = dateTime.getSeconds();
    obj.milliseconds = dateTime.getMilliseconds();
    return obj;
  },
  formatTime: function formatTime(time, str, flag) {
    str = str || "-";
    var now = new Date(parseInt(time));
    var year = now.getFullYear();
    var month = now.getMonth() < 9 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
    var day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
    var hours = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
    return year + str + month + str + day + (flag ? " " + hours + ":" + minute + ":" + second : "");
  },
  getImgUrlBase64: function getImgUrlBase64(fileObj, name, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(fileObj);
    reader.onload = function (e) {
      callback && callback(e.target.result, name);
    };
  },
  imageZip: function imageZip(opt) {
    var _this = this;
    var img = new Image();
    img.src = opt.src;
    var size = opt.size || 1024 * 1024;
    img.onload = function () {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var width = img.width * 0.9;
      var height = img.height * 0.9;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      var url = canvas.toDataURL(opt.type || "image/jpeg", .5);
      if (url.length > size) {
        _this.imageZip({
          src: url,
          type: opt.type,
          size: size,
          callback: opt.callback
        });
        return;
      }
      opt.callback && opt.callback(url);
    };
  },
  getAes256Data: function getAes256Data(data) {
    var key = sessionStorage.getItem("CM_KEY");
    var aesflag = aes.enc.Utf8.parse(key),
        options = {
      iv: aes.enc.Utf8.parse("0000000000000000"),
      mode: aes.mode.CBC,
      padding: aes.pad.Pkcs7
    };
    var encryptedData = aes.AES.encrypt(data, aesflag, options);
    var encData = encryptedData.toString();
    return encData;
  },
  calcTplHeight: function calcTplHeight(opts) {
    var calcNum;
    var span = document.createElement("span");
    var text = document.createTextNode(opts.str);
    span.appendChild(text);
    span.className = "print-hide";
    span.style.position = "absolute";
    span.style.fontSize = "12px";
    span.style.top = "-1000px";
    span.style.let = "-1px";
    span.style.whiteSpace = "nowrap";
    span.style.height = "auto";
    span.style.lineHeight = opts.lh + "px";
    document.body.appendChild(span);

    opts.minNum = opts.minNum || 1;
    calcNum = span.offsetWidth / opts.fixW;

    calcNum = Math.floor(opts.floor && calcNum > Math.floor(calcNum) ? calcNum + 1 : calcNum);
    if (calcNum > 10) {
      return calcNum * opts.lh + 10;
    }
    return calcNum > opts.minNum ? calcNum * opts.lh : opts.minNum * opts.lh;
  },
  getQueryArgs: function getQueryArgs(url) {
    var qs = url.length > 0 ? url.substring(url.indexOf("?")).substr(1) : "",
        args = {},
        items = qs.length ? qs.split("&") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;

    for (i = 0; i < len; i++) {
      item = items[i].split("="), name = decodeURIComponent(item[0]);
      value = decodeURIComponent(item[1]);
      if (name.length) {
        args[name] = value;
      }
    }
    return args;
  },
  getByteLen: function getByteLen(val) {
    var len = 0;
    for (var i = 0; i < val.length; i++) {
      var a = val.charAt(i);
      if (a.match(/[^\x00-\xff]/ig) != null) {
        len += 2;
      } else {
        len += 1;
      }
    }
    return len;
  },
  getRandom: function getRandom(min, max) {
    return Math.round(Math.random() * (max - min) + min);
  },
  getCode: function getCode(len) {
    var code = "";
    for (var i = 0; i < len; i++) {
      var type = this.getRandom(1, 3);
      switch (type) {
        case 1:
          code += String.fromCharCode(this.getRandom(48, 57));
          break;
        case 2:
          code += String.fromCharCode(this.getRandom(65, 90));
          break;
        case 3:
          code += String.fromCharCode(this.getRandom(97, 122));
          break;
      }
    }
    return code;
  },
  cnnumtonum: function cnnumtonum(chnStr) {
    var chnNumChar = {
      "零": 0,
      "壹": 1,
      "贰": 2,
      "叁": 3,
      "肆": 4,
      "伍": 5,
      "陆": 6,
      "柒": 7,
      "捌": 8,
      "玖": 9
    };
    var chnNameValue = {
      "拾": {
        value: 10,
        secUnit: false
      },
      "佰": {
        value: 100,
        secUnit: false
      },
      "仟": {
        value: 1000,
        secUnit: false
      },
      "万": {
        value: 10000,
        secUnit: true
      },
      "亿": {
        value: 100000000,
        secUnit: true
      }
    };
    var expNumChar = {
      "拾": 10,
      "拾壹": 11,
      "拾贰": 12,
      "拾叁": 13,
      "拾肆": 14,
      "拾伍": 15,
      "拾陆": 16,
      "拾柒": 17,
      "拾捌": 18,
      "拾玖": 19
    };
    if (expNumChar[chnStr]) {
      return expNumChar[chnStr];
    }
    var rtn = 0;
    var section = 0;
    var number = 0;
    var secUnit = false;
    var str = chnStr.split("");
    for (var i = 0; i < str.length; i++) {
      var num = chnNumChar[str[i]];
      if (typeof num !== "undefined") {
        number = num;
        if (i === str.length - 1) {
          section += number;
        }
      } else {
        var cunit = chnNameValue[str[i]];
        if (typeof cunit == "undefined") {
          return false;
        }
        var unit = chnNameValue[str[i]].value;
        secUnit = chnNameValue[str[i]].secUnit;
        if (secUnit) {
          section = (section + number) * unit;
          rtn += section;
          section = 0;
        } else {
          section += number * unit;
        }
        number = 0;
      }
    }
    return rtn + section;
  },
  valiteAge: function valiteAge(age) {
    var birthYear = age[0];
    var birthMonth = age[1];
    var birthDay = age[2];

    var now = new Date();
    var nowYear = now.getFullYear();
    var nowMonth = now.getMonth() + 1;
    var nowDay = now.getDate();
    if (nowYear - birthYear < 18) {
      return false;
    }
    if (nowYear - birthYear == 18) {
      if (nowMonth < birthMonth) {
        return false;
      }
      if (nowMonth == birthMonth) {
        if (nowDay < birthDay) {
          return false;
        }
      }
    }
    return true;
  },
  checkSeriesStr: function checkSeriesStr(str) {
    var ncontinuity = 0;
    for (var i = 1, l = str.length; i < l; i++) {
      if (str[i] - str[i - 1] == 1 || str[i] - str[i - 1] == -1) {
        ncontinuity += 1;
      }
    }
    if (ncontinuity > str.length - 2) {
      return true;
    }
    return false;
  },
  checkSameStr: function checkSameStr(str) {
    if (!str) {
      return false;
    }
    var a = str[0];
    var flag = true;
    for (var i = 1, l = str.length; i < l; i++) {
      if (a !== str[i]) {
        flag = false;
      }
    }
    return flag;
  },
  getUserIP: function getUserIP(onNewIP) {
    try {
      var iterateIP = function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      };

      var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      var pc = new myPeerConnection({
        iceServers: []
      }),
          noop = function noop() {},
          localIPs = {},
          ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
          key;

      pc.createDataChannel("");

      pc.createOffer().then(function (sdp) {
        sdp.sdp.split("\n").forEach(function (line) {
          if (line.indexOf("candidate") < 0) return;
          line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
      }).catch(function (reason) {});

      pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    } catch (err) {
      window.consoleError && window.consoleError("ip获取失败", err);
    }
  },
  getOSAndBrowser: function getOSAndBrowser() {
    var os = navigator.platform;
    var userAgent = navigator.userAgent;
    var info = "";
    var tempArray = "";
    if (os.indexOf("Win") > -1) {
      if (userAgent.indexOf("Windows NT 5.0") > -1) {
        info += "Windows 2000";
      } else if (userAgent.indexOf("Windows NT 5.1") > -1) {
        info += "Windows XP";
      } else if (userAgent.indexOf("Windows NT 5.2") > -1) {
        info += "Windows 2003";
      } else if (userAgent.indexOf("Windows NT 6.0") > -1) {
        info += "Windows Vista";
      } else if (userAgent.indexOf("Windows NT 6.1") > -1 || userAgent.indexOf("Windows 7") > -1) {
        info += "Windows 7";
      } else if (userAgent.indexOf("Windows NT 6.2") > -1 || userAgent.indexOf("Windows NT 6.3") > -1 || userAgent.indexOf("Windows 8") > -1) {
        info += "Windows 8";
      } else if (userAgent.indexOf("Windows NT 6.4") > -1 || userAgent.indexOf("Windows NT 10") > -1) {
        info += "Windows 10";
      } else {
        info += "Other";
      }
    } else if (os.indexOf("Mac") > -1) {
      info += "Mac";
    } else if (os.indexOf("X11") > -1) {
      info += "Unix";
    } else if (os.indexOf("Linux") > -1) {
      info += "Linux";
    } else {
      info += "Other";
    }
    info += "/";
    if (/[Ff]irefox(\/\d+\.\d+)/.test(userAgent)) {
      tempArray = /([Ff]irefox)\/(\d+\.\d+)/.exec(userAgent);
      info += tempArray[1] + tempArray[2];
    } else if (/[Tt]rident(\/\d+\.\d+)/.test(userAgent)) {
      tempArray = /([Tt]rident)\/(\d+\.\d+)/.exec(userAgent);
      if (tempArray[2] === "7.0") {
        tempArray[2] = "11";
      } else if (tempArray[2] === "6.0") {
        tempArray[2] = "10";
      } else if (tempArray[2] === "5.0") {
        tempArray[2] = "9";
      } else if (tempArray[2] === "4.0") {
        tempArray[2] = "8";
      }
      tempArray[1] = "IE";
      info += tempArray[1] + tempArray[2];
    } else if (/[Cc]hrome\/\d+/.test(userAgent)) {
      tempArray = /([Cc]hrome)\/(\d+)/.exec(userAgent);
      info += tempArray[1] + tempArray[2];
    } else if (/[Vv]ersion\/\d+\.\d+\.\d+(\.\d)* *[Ss]afari/.test(userAgent)) {
      tempArray = /[Vv]ersion\/(\d+\.\d+\.\d+)(\.\d)* *([Ss]afari)/.exec(userAgent);
      info += tempArray[3] + tempArray[1];
    } else if (/[Oo]pera.+[Vv]ersion\/\d+\.\d+/.test(userAgent)) {
      tempArray = /([Oo]pera).+[Vv]ersion\/(\d+)\.\d+/.exec(userAgent);
      info += tempArray[1] + tempArray[2];
    } else {
      info += "unknown";
    }
    return info;
  },
  changeDataFormat: function changeDataFormat(dateTime) {
    var dateee, time;
    if (dateTime.length != 8) {
      dateee = new Date(dateTime).toJSON();
      time = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, " ").replace(/\.[\d]{3}Z/, "");
      time = time.split(" ")[0].split("-").join("");
    } else {
      time = dateTime;
    }
    return time;
  },
  valHasEle: function valHasEle(val1, val2, key2) {
    return val2.every(function (v) {
      return v[key2] != val1;
    });
  },
  isNumLetter: function isNumLetter(value) {
    var reg = /^[0-9a-zA-Z]*$/;
    if (!reg.test(value)) {
      return false;
    } else {
      return true;
    }
  },

  isNumber: function isNumber(value) {
    if (value === "" || value === undefined || value === null) {
      return false;
    }
    var reg = /\s/g;
    if (reg.test(value)) {
      return false;
    }
    return !isNaN(value);
  },
  global: {
    LONGTIME: new Date("3000-12-31").getTime(),
    NODE_ENV: process.env.NODE_ENV,
    IS_CHROME: navigator.userAgent.indexOf("Chrome") != -1,
    QRCODE: true }
};


//////////////////
// WEBPACK FOOTER
// ./src/oldCode/commonTools/util.js
// module id = 125
// module chunks = 2